<template>
  <div class="inventoryTransferDetail">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <h2 style="margin-right: 20px;">{{ data.transfer.id ? '编辑' : '新增' }}调拨（调入）</h2>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="primary" @click="receive()" :loading="show.saving">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="调出日期">
            <el-date-picker style="width: 100%;" v-model="data.transfer.outDate" type="date" @change="handleChangeOutDate()" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调入日期">
            <el-date-picker style="width: 100%;" v-model="data.transfer.inDate" type="date" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调出仓储">
            <el-select v-model="data.transfer.outStorage" filterable @change="loadInventoryList()">
              <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调入仓储">
            <el-select v-model="data.transfer.inStorage" filterable @change="findTransDedProcureFormula(); findTransServProcureFormula();">
              <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运输公司">
            <el-select v-model="data.transfer.transportCompany" filterable>
              <el-option v-for='transportCompanyItem in show.transportCompanyList' :key="transportCompanyItem.id" :label="transportCompanyItem.value" :value="transportCompanyItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input v-model="data.transfer.truckNumber" :max="100" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注信息">
            <el-input v-model="data.transfer.note" :max="100" />
          </el-form-item>
        </el-col>
        <el-divider content-position="left">数量</el-divider>
        <el-col :span="8">
          <el-form-item label="重车数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outQuantityGross" @change="updateOutQuantityInitial()" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="皮重数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outQuantityTare" @change="updateOutQuantityInitial()" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="涨吨数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outExpandedQuantity" @change="updateOutQuantityInitial()" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-tooltip effect="dark" content="原始的出库数量（重车数量-皮重数量-涨吨数量）" placement="bottom">
            <el-form-item label="出库数量">
              <el-input-number disabled style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outQuantityInitial" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <el-form-item label="退车数量">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.inQuantityBack" @change="updateInQuantityBack()" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-tooltip effect="dark" content="本车最终扣减调出仓的数量（出库数量-退车数量），退车部分按配比退回调出仓" placement="bottom">
            <el-form-item label="调出数量">
              <el-input-number disabled style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.outQuantity" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <el-tooltip effect="dark" content="运输后原始的到达数量，计算亏吨与运费用，退车不影响此数量" placement="bottom">
            <el-form-item label="到货数量">
              <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.inQuantityOriginal" @change="updateInQuantityOriginal()" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <el-tooltip effect="dark" content="出库数量+涨吨数量-到货数量" placement="bottom">
            <el-form-item label="运输亏吨">
              <el-input-number disabled style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.lossQuantity" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <el-tooltip effect="dark" content="最终增加调入仓的数量（到货数量-退车数量）" placement="bottom">
            <el-form-item label="调入方验收">
              <el-input-number disabled style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.inQuantity" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-divider content-position="left">配比与入库方式</el-divider>
        <el-col :span="12">
          <el-form-item label="入库方式">
            <el-radio-group v-model="data.transfer.inMixSplit">
              <el-radio :value="true">按配比拆分入库</el-radio>
              <el-radio :value="false">混合入库同一品名</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入库煤矿品名" v-if="data.transfer.inMixSplit === false">
            <el-select v-model="data.transfer.inMergeProduct" filterable>
              <el-option v-for='productItem in show.productList' :key="productItem.id" :label="productItem.value" :value="productItem.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="销售品名">
            <el-select v-model="data.transfer.customNote" @change="handleCustomNoteSelect" filterable clearable :placeholder="data.transfer.outDate ? '不必填，选了会自动带出配比' : '请先选择调出日期'">
              <el-option v-for='customNote in show.customNoteList' :key="customNote.id" :label="customNote.customNote" :value="customNote.customNote" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="配比">
            <el-table :data="data.transfer.mixDetailList" border height="210px">
              <el-table-column label="" width="80" header-align="center" align="center">
                <template #default="scope">
                  <el-link type="danger" @click="delRow(scope.row)" v-if="scope.row.product">删除</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="product" label="煤矿品名" header-align="center">
                <template #default="scope">
                  <el-select style="width: 100%;" v-model="scope.row.product" filterable @change="checkRowProduct(scope.row)">
                    <el-option v-for='productItem in show.productList' :key="productItem.id" :label="productItem.value" :value="productItem.value" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="mixNumber" label="占比" header-align="center">
                <template #default="scope">
                  <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="scope.row.mixNumber" @change="computeMix()" />
                </template>
              </el-table-column>
              <el-table-column prop="outQuantity" label="调出数量" header-align="center">
                <template #default="scope">
                  <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="scope.row.outQuantity" @change="changeMixQuantity()" />
                </template>
              </el-table-column>
              <el-table-column label="调入数量" width="120" header-align="center" align="right">
                <template #default="scope">
                  <el-text v-if="data.transfer.inMixSplit !== false">{{ math.formatNumber(inQuantityOfRow(scope.row)) }}</el-text>
                  <el-text type="info" v-else>混合入库</el-text>
                </template>
              </el-table-column>
              <el-table-column label="调出仓库存" width="130" header-align="center" align="right">
                <template #default="scope">
                  <el-text v-if="scope.row.product" :type="inventoryQuantity(scope.row.product) < scope.row.outQuantity ? 'danger' : ''">
                    {{ math.formatNumber(inventoryQuantity(scope.row.product)) }}
                  </el-text>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
        <el-divider content-position="left">运费</el-divider>
        <el-col :span="12">
          <el-form-item label="调拨运费单价">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.transferTransportPrice" @change="computeTransportAmountAfterDeduction()" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小计">
            <el-text style="width: 100%;text-align: center;">{{ math.formatNumber(math.multiply(data.transfer.inQuantityOriginal, data.transfer.transferTransportPrice)) }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运费扣除">
            <el-input-number style="width: calc(100% - 70px)" :controls="false" :precision="2" v-model="data.transfer.transferTransportDeductionAmount" @change="computeTransportAmountAfterDeduction()" />
            <el-link type="primary" style="margin-left: 20px;" @click="show.transDedAmountFormulaDialog = true">公式</el-link>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实付运费">
            <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.transferTransportAmountAfterDeduction" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务费">
            <el-input-number style="width: calc(100% - 70px)" :controls="false" :precision="2" v-model="data.transfer.transferTransportServiceAmount" @change="computeTransportAmount()" />
            <el-link type="primary" style="margin-left: 20px;" @click="show.transServAmountFormulaDialog = true">公式</el-link>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-tooltip effect="dark" content="实付运费+服务费，即本次调拨新发生的运费，参与调入仓储的加权平均" placement="bottom">
            <el-form-item label="运费合计">
              <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.transfer.transferTransportAmount" />
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-text type="info">
              保存后调入仓按<b>总成本 / 总运费</b>重新加权平均。总成本 = 各品名调出数量 × 调出单价，
              总运费 = 各品名调出数量 × 调出运费单价 + 运费合计；亏吨不减成本，所以调入单价会略高于调出单价。
              运费扣除、服务费公式沿用<b>上游运费</b>的那两套。
            </el-text>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>

  <el-dialog v-model="show.transDedAmountFormulaDialog" title="选择运费扣除公式（上游运费扣除）" width="650">
    <el-table :data="show.transDedAmountFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text v-show="!scope.row.default">{{ scope.row.name }}</el-text>
          <el-text v-show="scope.row.default" type="primary">{{ '【默认】' + scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="200">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useTransDedAmountFormula(scope.row)">使用</el-button>
            <el-button @click="useTransDedAmountFormulaAndSetDefault(scope.row)">并标记默认</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog v-model="show.transServAmountFormulaDialog" title="选择服务费公式（上游运费服务费）" width="650">
    <el-table :data="show.transServAmountFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text v-show="!scope.row.default">{{ scope.row.name }}</el-text>
          <el-text v-show="scope.row.default" type="primary">{{ '【默认】' + scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="200">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useTransServAmountFormula(scope.row)">使用</el-button>
            <el-button @click="useTransServAmountFormulaAndSetDefault(scope.row)">并标记默认</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script setup>
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const show = reactive({
  saving: false,
  storageList: [],
  productList: [],
  transportCompanyList: [],
  customNoteList: [],
  inventoryMap: {},
  transDedAmountFormulaList: [],
  transServAmountFormulaList: [],
  transDedAmountFormulaDialog: false,
  transServAmountFormulaDialog: false,
})
const pageParam = cache.getObject(cache.keys.pageParam + "inventoryTransferDetail")
const data = reactive({
  transfer: pageParam ? JSON.parse(JSON.stringify(pageParam)) : { mixDetailList: [] }
})
if (!data.transfer.mixDetailList) {
  data.transfer.mixDetailList = []
}
/** 配比表格：任何一次改动都刷新，始终只保留一个位于最下方的空行（空行不显示删除按钮） */
const refreshBlankRow = () => {
  const list = data.transfer.mixDetailList
  for (let i = list.length - 1; i >= 0; i--) {
    if (!list[i].product) {
      list.splice(i, 1)
    }
  }
  list.push({})
}
refreshBlankRow()
// 调入方式默认混合入库同一品名。还没调入的单，主表里那个值只是调出环节写的占位（恒为 true），
// 不能当成用户的选择，所以这里一律按默认值给，已经调入过的单才沿用它自己的选择。
if (!data.transfer.inDate || data.transfer.inMixSplit === null || data.transfer.inMixSplit === undefined) {
  data.transfer.inMixSplit = false
}
// 到货数量默认按出库数量带出，避免调入方每次都手填一遍
if (data.transfer.id && !data.transfer.inDate) {
  data.transfer.inQuantityBack = data.transfer.inQuantityBack || 0
  data.transfer.inQuantityOriginal = data.transfer.inQuantityOriginal || data.transfer.outQuantityInitial
}

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'product' } }).then(res => {
  show.productList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'transportCompany' } }).then(res => {
  show.transportCompanyList = res.dictList
})

/** 运费扣除公式：沿用上游运费的那套，默认公式按调入仓储记（调入仓就是这批货的到货仓） */
const findTransDedProcureFormula = () => {
  const formulaParam = { model: 'transDedProcure' }
  if (data.transfer.inStorage) {
    formulaParam.defaultKey = data.transfer.inStorage
  }
  api.get('/backend/formula/get', { params: formulaParam }).then(res => {
    show.transDedAmountFormulaList = res.list
    if (res.data && res.data.default) {
      for (let formula of show.transDedAmountFormulaList) {
        if (formula.id == res.data.default.id) {
          formula.default = true
        }
      }
    }
  })
}
findTransDedProcureFormula()

/** 服务费公式：同样沿用上游运费的那套 */
const findTransServProcureFormula = () => {
  const formulaParam = { model: 'transServProcure' }
  if (data.transfer.inStorage) {
    formulaParam.defaultKey = data.transfer.inStorage
  }
  api.get('/backend/formula/get', { params: formulaParam }).then(res => {
    show.transServAmountFormulaList = res.list
    if (res.data && res.data.default) {
      for (let formula of show.transServAmountFormulaList) {
        if (formula.id == res.data.default.id) {
          formula.default = true
        }
      }
    }
  })
}
findTransServProcureFormula()

const loadInventoryList = () => {
  show.inventoryMap = {}
  if (!data.transfer.outStorage) {
    return
  }
  api.get('/backend/inventory/list', { params: { storage: data.transfer.outStorage } }).then(res => {
    const map = {}
    for (const item of res.list) {
      map[item.product] = item
    }
    show.inventoryMap = map
  })
}
loadInventoryList()

/** 配比表格里逐行提示调出仓够不够扣，不然要等保存被后台驳回才知道是哪个品名短 */
const inventoryQuantity = (product) => {
  const item = show.inventoryMap[product]
  return item ? item.quantity : 0
}

const handleChangeOutDate = () => {
  show.customNoteList = []
  if (data.transfer.outDate) {
    const useDate = util.parseTime(data.transfer.outDate, '{y}-{m}-{d}')
    api.get('/backend/customNoteToMix/all', { params: { useDate } }).then(res => {
      show.customNoteList = res.list
    })
  }
}
if (data.transfer.outDate) {
  const useDate = util.parseTime(data.transfer.outDate, '{y}-{m}-{d}')
  api.get('/backend/customNoteToMix/all', { params: { useDate } }).then(res => {
    show.customNoteList = res.list
  })
}

const handleCustomNoteSelect = (customNoteString) => {
  if (!customNoteString) {
    return
  }
  const customNote = show.customNoteList.filter(x => x.customNote == customNoteString)[0]
  if (!customNote) {
    return
  }
  data.transfer.mixDetailList = customNote.mixList.map(item => {
    return { product: item.product, mixNumber: item.mixNumber }
  })
  refreshBlankRow()
  computeMix()
}

const delRow = (row) => {
  data.transfer.mixDetailList = data.transfer.mixDetailList.filter(item => item.product != row.product)
  refreshBlankRow()
  computeMix()
}

const checkRowProduct = (row) => {
  const l1 = data.transfer.mixDetailList.length
  const l2 = data.transfer.mixDetailList.filter(item => item.product != row.product).length
  if (l1 != l2 + 1) {
    ElMessage.error("煤矿品名重复")
    row.product = null
  }
  // 改已有行也走这里：以前只在 else 里 push 空行，改一次就多一行空行
  refreshBlankRow()
}

/** 出库数量 = 重车 - 皮重 - 涨吨 */
const updateOutQuantityInitial = () => {
  data.transfer.outQuantityInitial = math.plus(data.transfer.outQuantityGross || 0, -(data.transfer.outQuantityTare || 0), -(data.transfer.outExpandedQuantity || 0))
  updateOutQuantity()
  updateLossQuantity()
}

/** 调出数量 = 出库数量 - 退车数量 */
const updateOutQuantity = () => {
  data.transfer.outQuantity = math.plus(data.transfer.outQuantityInitial || 0, -(data.transfer.inQuantityBack || 0))
  computeMix()
}

const updateInQuantityBack = () => {
  updateOutQuantity()
  data.transfer.inQuantity = math.plus(data.transfer.inQuantityOriginal || 0, -(data.transfer.inQuantityBack || 0))
}

/** 运输亏吨 = 出库数量 + 涨吨 - 到货数量 */
const updateLossQuantity = () => {
  data.transfer.lossQuantity = math.plus(data.transfer.outQuantityInitial || 0, data.transfer.outExpandedQuantity || 0, -(data.transfer.inQuantityOriginal || 0))
}

const updateInQuantityOriginal = () => {
  updateLossQuantity()
  data.transfer.inQuantity = math.plus(data.transfer.inQuantityOriginal || 0, -(data.transfer.inQuantityBack || 0))
  computeTransportAmountAfterDeduction()
}

/** 按占比把调出数量摊到各品名，尾差落在最后一行 */
const computeMix = () => {
  if (data.transfer.mixDetailList == null) {
    return
  }
  const mixDetailList = data.transfer.mixDetailList.filter(x => x.product)
  if (data.transfer.outQuantity && mixDetailList.length > 0) {
    let mixNumber = 0
    for (const i in mixDetailList) {
      mixNumber = math.plus(mixNumber, mixDetailList[i].mixNumber || 0)
    }
    if (mixNumber > 0) {
      let sumQuantity = 0
      for (const i in mixDetailList) {
        const mixDetailItem = mixDetailList[i]
        if (!mixDetailItem.mixNumber) {
          mixDetailItem.outQuantity = 0
        } else {
          if (i < mixDetailList.length - 1) {
            mixDetailItem.outQuantity = math.halfUp(data.transfer.outQuantity * mixDetailItem.mixNumber / mixNumber, 2)
          } else {
            mixDetailItem.outQuantity = math.plus(data.transfer.outQuantity, -sumQuantity)
          }
          sumQuantity = math.plus(sumQuantity, mixDetailItem.outQuantity)
        }
      }
      ElMessage.success('已自动配比数量')
    }
  }
}

const changeMixQuantity = () => {
  for (const mixIndex in data.transfer.mixDetailList) {
    const mixDetail = data.transfer.mixDetailList[mixIndex]
    if (mixDetail.outQuantity && mixDetail.product) {
      mixDetail.mixNumber = mixDetail.outQuantity
    }
  }
}

/** 展示用：本品名按调出数量占比分到的调入数量（落库口径与后台一致） */
const inQuantityOfRow = (row) => {
  if (!row.product || !row.outQuantity || !data.transfer.outQuantity) {
    return 0
  }
  return math.halfUp(data.transfer.inQuantity * row.outQuantity / data.transfer.outQuantity, 2)
}

/** 实付运费 = 到货数量 × 调拨运费单价 - 运费扣除，向下抹到十位（与上游运费一致） */
const computeTransportAmountAfterDeduction = (silent) => {
  if (data.transfer.inQuantityOriginal && data.transfer.transferTransportPrice) {
    let amountAfterDeduction = math.plus(math.multiply(data.transfer.inQuantityOriginal, data.transfer.transferTransportPrice), -(data.transfer.transferTransportDeductionAmount || 0))
    amountAfterDeduction = math.floor(amountAfterDeduction, -1)
    if (data.transfer.transferTransportAmountAfterDeduction != amountAfterDeduction) {
      data.transfer.transferTransportAmountAfterDeduction = amountAfterDeduction
      computeTransportAmount(silent)
    }
  }
}

/** 运费合计 = 实付运费 + 服务费 */
const computeTransportAmount = (silent) => {
  data.transfer.transferTransportAmount = math.plus(data.transfer.transferTransportServiceAmount, data.transfer.transferTransportAmountAfterDeduction)
  if (silent !== true) {
    ElMessage.success('运费已自动更新')
  }
}

/** 喂给公式的变量：上游运费公式用的是发货数量/到货数量/实付运费，其余是调拨特有的 */
const formulaContext = () => {
  return {
    发货数量: data.transfer.outQuantityInitial || 0,
    到货数量: data.transfer.inQuantityOriginal || 0,
    重车数量: data.transfer.outQuantityGross || 0,
    皮重数量: data.transfer.outQuantityTare || 0,
    涨吨数量: data.transfer.outExpandedQuantity || 0,
    出库数量: data.transfer.outQuantityInitial || 0,
    退车数量: data.transfer.inQuantityBack || 0,
    调出数量: data.transfer.outQuantity || 0,
    运输亏吨: data.transfer.lossQuantity || 0,
    调入方验收: data.transfer.inQuantity || 0,
    实付运费: data.transfer.transferTransportAmountAfterDeduction || 0,
  }
}

const runFormula = (formula) => {
  const ctx = formulaContext()
  let 结果 = null
  const 发货数量 = ctx.发货数量
  const 到货数量 = ctx.到货数量
  const 重车数量 = ctx.重车数量
  const 皮重数量 = ctx.皮重数量
  const 涨吨数量 = ctx.涨吨数量
  const 出库数量 = ctx.出库数量
  const 退车数量 = ctx.退车数量
  const 调出数量 = ctx.调出数量
  const 库存扣减 = ctx.调出数量
  const 运输亏吨 = ctx.运输亏吨
  const 调入方验收 = ctx.调入方验收
  const 最终验收 = ctx.调入方验收
  const 实付运费 = ctx.实付运费
  console.info(ctx)
  eval(formula.jsScript)
  return 结果
}

const useTransDedAmountFormulaAndSetDefault = (formula) => {
  if (!data.transfer.inStorage) {
    ElMessage.error('没有选择调入仓储，无法设置默认公式')
    return
  }
  api.post('/backend/formula/setDefault', {
    model: 'transDedProcure',
    key: data.transfer.inStorage,
    formulaId: formula.id
  }).then(() => {
    ElMessage.success('公式已设为' + data.transfer.inStorage + '默认')
    useTransDedAmountFormula(formula)
  })
}

const useTransDedAmountFormula = (formula) => {
  try {
    const 结果 = runFormula(formula)
    if (结果 === null) {
      ElMessage.error('公式有误，请手动填写')
      return
    }
    data.transfer.transferTransportDeductionAmount = math.halfUp(结果, 2)
    computeTransportAmountAfterDeduction()
    show.transDedAmountFormulaDialog = false
  } catch (error) {
    ElMessage.error('公式有误，请手动填写')
    console.error(error)
  }
}

const useTransServAmountFormulaAndSetDefault = (formula) => {
  if (!data.transfer.inStorage) {
    ElMessage.error('没有选择调入仓储，无法设置默认公式')
    return
  }
  api.post('/backend/formula/setDefault', {
    model: 'transServProcure',
    key: data.transfer.inStorage,
    formulaId: formula.id
  }).then(() => {
    ElMessage.success('公式已设为' + data.transfer.inStorage + '默认')
    useTransServAmountFormula(formula)
  })
}

const useTransServAmountFormula = (formula) => {
  try {
    const 结果 = runFormula(formula)
    if (结果 === null) {
      ElMessage.error('公式有误，请手动填写')
      return
    }
    data.transfer.transferTransportServiceAmount = math.halfUp(结果, 2)
    computeTransportAmount()
    show.transServAmountFormulaDialog = false
  } catch (error) {
    ElMessage.error('公式有误，请手动填写')
    console.error(error)
  }
}

const receive = () => {
  if (show.saving) {
    return
  }
  const transfer = data.transfer
  if (!transfer.outDate) {
    ElMessage.error('请选择调出日期')
    return
  }
  if (!transfer.inDate) {
    ElMessage.error('请选择调入日期')
    return
  }
  if (!transfer.outStorage || !transfer.inStorage) {
    ElMessage.error('请选择调出仓储与调入仓储')
    return
  }
  if (!transfer.transportCompany) {
    ElMessage.error('请选择运输公司')
    return
  }
  if (!transfer.truckNumber) {
    ElMessage.error('请填写车牌号')
    return
  }
  if (transfer.inMixSplit === false && !transfer.inMergeProduct) {
    ElMessage.error('选择了混合入库同一品名，请填写入库的煤矿品名')
    return
  }
  if (!(transfer.inQuantity > 0)) {
    ElMessage.error('调入方验收数量必须大于0（到货数量-退车数量）')
    return
  }
  const mixDetailList = transfer.mixDetailList.filter(item => item.product && item.outQuantity)
  if (mixDetailList.length == 0) {
    ElMessage.error('请填写配比')
    return
  }
  let sumOutQuantityMix = 0
  mixDetailList.forEach(mixDetail => {
    sumOutQuantityMix = math.plus(sumOutQuantityMix, mixDetail.outQuantity)
  })
  if (sumOutQuantityMix != transfer.outQuantity) {
    ElMessage.error("配比数量不等于调出数量，请重新填写配比数量")
    return
  }
  const param = { id: transfer.id }
  param.outDate = util.parseTime(transfer.outDate, '{y}-{m}-{d}')
  param.inDate = util.parseTime(transfer.inDate, '{y}-{m}-{d}')
  param.outStorage = transfer.outStorage
  param.inStorage = transfer.inStorage
  param.transportCompany = transfer.transportCompany
  param.truckNumber = transfer.truckNumber
  param.customNote = transfer.customNote
  param.note = transfer.note
  param.outQuantityGross = transfer.outQuantityGross || 0
  param.outQuantityTare = transfer.outQuantityTare || 0
  param.outExpandedQuantity = transfer.outExpandedQuantity || 0
  param.outQuantityInitial = transfer.outQuantityInitial || 0
  param.outQuantity = transfer.outQuantity
  param.inQuantityBack = transfer.inQuantityBack || 0
  param.inQuantityOriginal = transfer.inQuantityOriginal || 0
  param.inQuantity = transfer.inQuantity
  param.inMixSplit = transfer.inMixSplit !== false
  param.inMergeProduct = transfer.inMixSplit === false ? transfer.inMergeProduct : null
  param.transferTransportPrice = transfer.transferTransportPrice || 0
  param.transferTransportDeductionAmount = transfer.transferTransportDeductionAmount || 0
  param.transferTransportAmountAfterDeduction = transfer.transferTransportAmountAfterDeduction || 0
  param.transferTransportServiceAmount = transfer.transferTransportServiceAmount || 0
  param.transferTransportAmount = transfer.transferTransportAmount || 0
  param.mixDetailList = mixDetailList.map(item => {
    return {
      product: item.product,
      mixNumber: item.mixNumber,
      outQuantity: item.outQuantity,
    }
  })
  show.saving = true
  api.post('/backend/inventoryTransfer/receive', param).then(() => {
    ElMessage.success('保存成功')
    router.go(-1)
  }).finally(() => {
    show.saving = false
  })
}

/**
 * 进页面先把派生字段算一遍。
 * 运输中的单从调出端过来时，运输亏吨、调入方验收还是空的，运费合计也被调出端写成0，
 * 不在这里补算的话：不动数量直接保存会被「调入方验收必须大于0」拦住，
 * 只改退车数量保存则会把整笔调拨运费漏掉。
 * 配比不在这里重算——它已经按调出数量分好了，填退车时再重分。
 * 运费只对还没调入的单自动补算，已调入的单可能被人工改过实付运费，不能覆盖。
 */
const initDerived = () => {
  if (!data.transfer.id) {
    return
  }
  data.transfer.outQuantityInitial = math.plus(data.transfer.outQuantityGross || 0, -(data.transfer.outQuantityTare || 0), -(data.transfer.outExpandedQuantity || 0))
  data.transfer.outQuantity = math.plus(data.transfer.outQuantityInitial, -(data.transfer.inQuantityBack || 0))
  data.transfer.lossQuantity = math.plus(data.transfer.outQuantityInitial, data.transfer.outExpandedQuantity || 0, -(data.transfer.inQuantityOriginal || 0))
  data.transfer.inQuantity = math.plus(data.transfer.inQuantityOriginal || 0, -(data.transfer.inQuantityBack || 0))
  if (!pageParam || !pageParam.inDate) {
    computeTransportAmountAfterDeduction(true)
  }
}
initDerived()
</script>

<style lang="less">
.inventoryTransferDetail {
  margin: auto;
  max-width: 900px;
}
</style>
